/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */ 

import { CallbackType, FRAuth, FRCallback, FRStep, StepType } from "@forgerock/javascript-sdk"
// import { isNil } from "lodash"
import isNil from 'lodash/isNil';
import { useEffect } from "react"
import FormLayout from "../../layout/form"
import { BaseCallBackInterface } from "./basInterface"

export const ResendLink = ({ step,
  setStep,
  tree,
  messageType,
  setMessageType,
  message,
  setMessage,
  isAlertOpen,
  setIsAlertOpen }: BaseCallBackInterface) => {

  useEffect(() => {
    if (!!step) {

    }

  }, [step])

  const resentCode = async (data: { callbackType: string, callbackValue: string, heading: string, type: string }) => {
    if (step && step.type === StepType.Step) {
      const fillStep = step
      switch (data.callbackType) {
        case "ConfirmationCallback":
          fillStep.getCallbackOfType(CallbackType.ConfirmationCallback).setInputValue(data.callbackValue);
          break;
      }
      setStep(fillStep);
      await callNextStep();
    }
  }

  const callNextStep = async () => {
    let nextStep = await FRAuth.next(step as FRStep, { tree });

    setStep(nextStep)
  }

  const getMetaDataUiElements = () => {
    let uiElement = <></>
    if (step && step.type === StepType.Step) {
      const metadataCallback: FRCallback[] = step.getCallbacksOfType(CallbackType.MetadataCallback);

      if (!isNil(metadataCallback) && metadataCallback.length) {
        const data = metadataCallback[0].getOutputByName('data', { callbackType: "", callbackValue: "", heading: "", type: "" });
        if (!!data) {
          switch (data.type) {
            case 'link':
              uiElement = <a href="javascript:void(0)" onClick={() => resentCode(data)}>{data.heading}</a>
              break;
            default:
              break;
          }
        }
      }
    }
    return uiElement;

  }

  return (

    <FormLayout
      header={step.getHeader()}
      subHeader={step.getDescription()}
      button={<></>}>
      {getMetaDataUiElements()}
    </FormLayout>
  )
}